/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';

export interface GetLicenseDataAccessModules$Request {
    licenseId: number;
}

export interface GetLicenseDataAccessModules$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getLicenseDataAccessModulesRequest = createAction<PayloadData<void, GetLicenseDataAccessModules$Request>>('GET_LICENSE_DATA_ACCESS_MODULES__GET_LICENSE_DATA_ACCESS_MODULES__REQUEST');
export const getLicenseDataAccessModulesSuccess = createAction<PayloadData<Array<string>, GetLicenseDataAccessModules$Request>>('GET_LICENSE_DATA_ACCESS_MODULES__GET_LICENSE_DATA_ACCESS_MODULES__SUCCESS');
export const getLicenseDataAccessModulesFailure = createAction<PayloadData<Error, GetLicenseDataAccessModules$Request, true>>('GET_LICENSE_DATA_ACCESS_MODULES__GET_LICENSE_DATA_ACCESS_MODULES__FAILURE');

export const getLicenseDataAccessModulesActions = [
    getLicenseDataAccessModulesRequest,
    getLicenseDataAccessModulesSuccess,
    getLicenseDataAccessModulesFailure
] as const;

/**
 * @param {number} meta.licenseId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getLicenseDataAccessModules = (meta: GetLicenseDataAccessModules$Request, config?: GetLicenseDataAccessModules$Config) => {
    return {
        CALL_API: {
            types: getLicenseDataAccessModulesActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/licenses/${meta.licenseId}/data-access-module`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

